import type { Effect, Reducer, Subscription } from "@umijs/max";
import type { SingleAdmUserType } from "./data";
import {
  addAdmUser,
  clearFailAdmUser,
  editAdmUser,
  getAdmUserPage,
  removeAdmUser,
} from "./service";

export type AdmUserState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleAdmUserType[];
};

type AdmUserModelType = {
  namespace: string;
  state: AdmUserState;
  reducers: {
    AdmUserReducer: Reducer<AdmUserState>;
  };
  effects: {
    fetchAdmUserPageEffect: Effect;
    refreshDataEffect: Effect;
    addAdmUserEffect: Effect;
    editAdmUserEffect: Effect;
    removeAdmUserEffect: Effect;
    clearFailEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: "refreshDataEffect",
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const AdmUserModel: AdmUserModelType = {
  namespace: "admUser",
  state: {
    code: 0,
    type: "",
    message: "success",
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    AdmUserReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as AdmUserState;
    },
  },

  effects: {
    *fetchAdmUserPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getAdmUserPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: "AdmUserReducer",
          payload: res,
        });
      } catch (e) {
        console.error("Fetch data failed:", e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.admUser.current);
      const pageSize = yield select((state: any) => state.admUser.pageSize);
      yield put({
        type: "fetchAdmUserPageEffect",
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    addAdmUserEffect: createEffect(addAdmUser),
    editAdmUserEffect: createEffect(editAdmUser),
    removeAdmUserEffect: createEffect(removeAdmUser),
    clearFailEffect: createEffect(clearFailAdmUser),
  },

  subscriptions: {
    setup() {},
  },
};

export default AdmUserModel;
